import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TrainingService } from '../../../services/training/training.service';
import { TrainingModuleListItem, TrainingProgress, moduleCode } from '../../../services/training/training.interface';

@Component({
  selector: 'app-training-hub',
  standalone: true,
  imports: [MatProgressSpinnerModule, RouterModule],
  templateUrl: './training-hub.component.html',
  styleUrl: './training-hub.component.css',
})
export class TrainingHubComponent implements OnInit {
  modules: TrainingModuleListItem[] = [];
  loading = true;

  constructor(private trainingService: TrainingService, private router: Router) {}

  ngOnInit(): void {
    this.trainingService.getModules().subscribe({
      next: (modules) => {
        this.modules = modules;
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }

  openModule(id: string): void {
    window.open(`/training/${id}`, '_blank');
  }

  getStatusLabel(progress: TrainingProgress | null): string {
    if (!progress || !progress.contentCompletedAt) return 'Not Started';
    if (progress.passed) return 'Passed';
    return 'In Progress';
  }

  getStatusClass(progress: TrainingProgress | null): string {
    if (!progress || !progress.contentCompletedAt) return 'status-not-started';
    if (progress.passed) return 'status-passed';
    return 'status-in-progress';
  }

  readonly moduleCode = moduleCode;

  get groupedModules(): { category: string; items: TrainingModuleListItem[] }[] {
    const map = new Map<string, TrainingModuleListItem[]>();
    for (const item of this.modules) {
      const key = item.module.category?.trim() || 'Uncategorized';
      if (!map.has(key)) map.set(key, []);
      map.get(key)!.push(item);
    }
    const sorted = Array.from(map.entries())
      .sort(([a], [b]) => {
        if (a === 'Uncategorized') return 1;
        if (b === 'Uncategorized') return -1;
        return a.localeCompare(b);
      });
    return sorted.map(([category, items]) => ({
      category,
      items: items.slice().sort((a, b) => {
        const sa = a.module.sequenceNumber ?? Infinity;
        const sb = b.module.sequenceNumber ?? Infinity;
        return sa - sb;
      }),
    }));
  }
}
